/**
 * Sprint Wizard Config Process Handlers
 * Read-only handlers for fetching sprint purpose and activity type configs from Firestore via Cloud Functions.
 */

import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'
import type { SprintPurposeConfig } from '../../../../pure-js/types/SprintPurposeConfig'
import type { ActivityTypeConfig } from '../../../../pure-js/types/ActivityTypeConfig'
import { handleRequest } from './config'
import type { ApiResponse } from '../types'

/**
 * Get all active sprint purpose configs
 */
export const getSprintPurposeConfigs = async (): Promise<ApiResponse<SprintPurposeConfig[]>> =>
  handleRequest(
    () => Promise.resolve({ data: [], success: true } as ApiResponse<SprintPurposeConfig[]>),
    async () => {
      const fn = httpsCallable<{ activeOnly: boolean }, { success: boolean; configs: SprintPurposeConfig[] }>(
        functions,
        'getSprintPurposeConfigs'
      )
      const result = await fn({ activeOnly: true })
      return { data: result.data.configs, success: true }
    }
  )

/**
 * Get all active activity type configs
 */
export const getSprintActivityTypeConfigs = async (): Promise<ApiResponse<ActivityTypeConfig[]>> =>
  handleRequest(
    () => Promise.resolve({ data: [], success: true } as ApiResponse<ActivityTypeConfig[]>),
    async () => {
      const fn = httpsCallable<{ activeOnly: boolean }, { success: boolean; configs: ActivityTypeConfig[] }>(
        functions,
        'getSprintActivityTypeConfigs'
      )
      const result = await fn({ activeOnly: true })
      return { data: result.data.configs, success: true }
    }
  )
